/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeeLeaveSettingsImport } from './EmployeeLeaveSettingsImport';
import {
    EmployeeLeaveSettingsImportFromJSON,
    EmployeeLeaveSettingsImportFromJSONTyped,
    EmployeeLeaveSettingsImportToJSON,
    EmployeeLeaveSettingsImportToJSONTyped,
} from './EmployeeLeaveSettingsImport';

/**
 * 
 * @export
 * @interface EmployeeLeaveSettingsImportResponse
 */
export interface EmployeeLeaveSettingsImportResponse {
    /**
     * 
     * @type {EmployeeLeaveSettingsImport}
     * @memberof EmployeeLeaveSettingsImportResponse
     */
    data: EmployeeLeaveSettingsImport;
}

/**
 * Check if a given object implements the EmployeeLeaveSettingsImportResponse interface.
 */
export function instanceOfEmployeeLeaveSettingsImportResponse(value: object): value is EmployeeLeaveSettingsImportResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function EmployeeLeaveSettingsImportResponseFromJSON(json: any): EmployeeLeaveSettingsImportResponse {
    return EmployeeLeaveSettingsImportResponseFromJSONTyped(json, false);
}

export function EmployeeLeaveSettingsImportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeLeaveSettingsImportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeLeaveSettingsImportFromJSON(json['data']),
    };
}

  export function EmployeeLeaveSettingsImportResponseToJSON(json: any): EmployeeLeaveSettingsImportResponse {
      return EmployeeLeaveSettingsImportResponseToJSONTyped(json, false);
  }

  export function EmployeeLeaveSettingsImportResponseToJSONTyped(value?: EmployeeLeaveSettingsImportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeLeaveSettingsImportToJSON(value['data']),
    };
}

